var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AbstractRepository } from 'packages/core/AbstractRepository';
import { AdAccount } from 'packages/target/entities/AdAccount';
import ENV from 'config/env';
import { EntityBuilder } from '@decahedron/entity';
var AdAccountRepository = /** @class */ (function (_super) {
    __extends(AdAccountRepository, _super);
    function AdAccountRepository() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.entity = AdAccount;
        _this.baseUrl = ENV.JOBILLA_API_ROOT + "target/v2";
        _this.url = 'ad-accounts';
        return _this;
    }
    AdAccountRepository.prototype.getAdAccounts = function () {
        var _this = this;
        return this.get(this.url).then(function (resp) { return EntityBuilder.buildMany(AdAccount, _this.responseTransformer(resp.data)); });
    };
    AdAccountRepository.prototype.getAdAccountUsedInRecruitment = function (jobId) {
        var _this = this;
        return this.get(this.baseUrl + "/jobs/" + jobId + "/ad-account").then(function (resp) { return EntityBuilder.buildOne(AdAccount, _this.responseTransformer(resp.data)); });
    };
    return AdAccountRepository;
}(AbstractRepository));
export { AdAccountRepository };
